import { types, flow, getParent } from 'mobx-state-tree';
import { timeRange, statuses, STATUS_TITLES } from '../../constants/orders';

const initialTimeRange = Object.keys(timeRange)[1];
const { failed } = STATUS_TITLES;

const OrderDashboardStats = types.model('OrderDashboardStats', {
  title: types.string,
  count: types.number,
});

const PieElememt = types.model('PieElememt', {
  key: types.number,
  value: types.number,
  color: types.string,
  status: types.string,
});

const DashboardData = types
  .model('DashboardData', {
    orderDashboardStats: types.optional(types.array(OrderDashboardStats), []),
    pieData: types.optional(types.array(PieElememt), []),
    selectedTimeRange: initialTimeRange,
    openTooltip: false,
    selectedChartPiece: '',
  })
  .actions(self => ({
    fetchDashboardData: flow(function* fetchDashboardData() {
      const url = 'order/v1/orders/dashboard';
      const { params, headers } = getParent(self).dashboardRequestData;
      if (!params.destinationMarketplace) {
        return;
      }
      const { data } = yield getParent(self).transport5007.fetch(url, params, headers);
      self.normalizeAndSetPieData(data.statuses);
      self.orderDashboardStats = data.info;
      self.resetTooltip();
    }),
    normalizeAndSetPieData(data) {
      self.pieData = data.reduce((acc, { title, count }) => {
        if (count !== 0) {
          acc.push({
            key: count,
            value: count,
            color: statuses[title].color,
            status: title,
          });
        }
        return acc;
      }, []);
    },
    setTimeRange(title) {
      if (title !== self.selectedTimeRange) {
        self.resetTooltip();
        self.selectedTimeRange = title;
        self.fetchDashboardData();
        getParent(self).fetchTableData();
      }
    },
    setInitialTimeRange() {
      self.selectedTimeRange = initialTimeRange;
    },
    handleChartClick({ data: { status, color } }) {
      const { filterValues } = getParent(self);
      if (filterValues.statuses.length) {
        filterValues.toggleSellectAllStatuses(filterValues.statuses.length);
      }
      filterValues.selectStatus(status);
      getParent(self).fetchNextPage(1);
      getParent(self).setChartFilter(status);
      self.openTooltip = true;
      self.selectedChartPiece = color;
      if (status === failed) {
        getParent(self).toggleActionBar(true);
      }
    },
    cancelChartFilter() {
      self.resetTooltip();
      const { filterValues } = getParent(self);
      if (filterValues.statuses.length) {
        filterValues.toggleSellectAllStatuses(filterValues.statuses.length);
      }
      getParent(self).fetchNextPage(1);
      getParent(self).setChartFilter('');
      getParent(self).toggleActionBar(false);
    },
    resetTooltip() {
      self.openTooltip = false;
      self.selectedChartPiece = '';
    },
  }));

export default DashboardData;
